import moment from "moment";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../api/firebase/references";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

const getGiInfo = async () => {
  try {
    const organization = getOrgIdForFetchExternalWorklist();
    const date = moment().format("YYYY-MM-DD");
    const response = await FirestoreService.getDocument(
      FirestoreDocumentReference.giInfoPath(organization, date),
    );
    const responseData = response as any;
    return {
      versions: responseData?.versions || {},
      total_unique_orders_stored: responseData?.total_unique_orders_stored || 0,
    };
  } catch (error) {
    console.error(error);
    return {
      versions: {},
      total_unique_orders_stored: 0,
    };
  }
};

export default getGiInfo;
